import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SamplePurchaseComponent } from './sample-purchase/sample-purchase.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/cart',
    pathMatch:'full'
   // loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'cart',
    loadChildren: () => import('./cart/cart.module').then(m => m.CartModule)
  },
  {
    path: 'cart/:id',
    loadChildren: () => import('./cart/cart.module').then(m => m.CartModule)
  },
  {
    path: 'cart/:id/:params',
    loadChildren: () => import('./cart/cart.module').then(m => m.CartModule)
  },
  {
    path: 'checkout',
    loadChildren: () => import('./checkout/checkout.module').then(m => m.CheckoutModule)
  },
  {
    path: 'sample-purchase',
    component: SamplePurchaseComponent
  },
  
  {path: '**', redirectTo: '/cart'}
  // {
  //   path: 'checkout/shipping',
  //   loadChildren: () => import('./checkout/checkout.module').then(m => m.CheckoutModule)
  // },
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
